module.exports = __webpack_public_path__ + "static/media/atrativos.881cd9a7.jpg";